import BackToGameButton from "components/Buttons/BackToGameButton";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";
import { ButtonWrapper, Container, Image, Subtitle, Title } from "./styles";

interface Props {
	title?: string;
	subtitle?: string;
	subtitle2?: string;
	buttonText?: string;
	imageUrl?: string;
}

const NoFriendsCard = ({
	title = "Friend Center",
	subtitle = "You don't have any TriPeaks Friends yet!",
	subtitle2 = "Add Friends to start gifting today!",
	buttonText = "Add Friends in the app",
	imageUrl
}: Props) => {
	const { getImage } = useImagePath("cdn");
	const fallbackImageUrl =
		imageUrl ?? getImage(friendCenterAssets.common.noFriends);

	return (
		<Container>
			<Title>{title}</Title>
			<Subtitle>{subtitle}</Subtitle>
			<Subtitle>{subtitle2}</Subtitle>
			<Image src={fallbackImageUrl} alt="No friends" />
			<ButtonWrapper>
				<BackToGameButton
					source="friend_center_no_friends"
					styles={{
						width: "100%",
						height: "3em",
						fontSize: "1em",
						textTransform: "none"
					}}
				>
					{buttonText}
				</BackToGameButton>
			</ButtonWrapper>
		</Container>
	);
};

export default NoFriendsCard;
